// helpers.ts — Pure utility functions for P922A (Leave Request) form

/** Convert ISO date string to HTML date input value (YYYY-MM-DD) */
export const dateToInput = (v: string | null | undefined): string => {
  if (!v) return '';
  return v.substring(0, 10);
};

/** Convert HTML date input value to ISO date string */
export const inputToDate = (v: string): string | null => {
  if (!v) return null;
  return v + 'T00:00:00Z';
};

/** Format number with locale grouping, max 2 decimals */
export const fmt = (v: number | null | undefined): string => {
  if (v == null || v === 0) return '0';
  return v.toLocaleString('en-US', { maximumFractionDigits: 2 });
};

/** Derive the approval status text for display */
export const getApprovalStatus = (record: { f921_30?: string } | null): { text: string; cls: string } | null => {
  if (!record) return null;
  switch (record.f921_30) {
    case 'Y': return { text: '已核准', cls: 'badge-success' };
    case 'N': return { text: '不准假', cls: 'badge-danger' };
    default: return { text: '尚未處理', cls: 'badge-default' };
  }
};

/**
 * BR-C05: Time auto-correction.
 * Single digit 1-6 maps to 13-18 (afternoon), 7-9 maps to 07-09 (morning).
 * e.g. "1:30" -> "13:30", "8:00" -> "08:00"
 */
export const autoCorrectTime = (raw: string): string => {
  const v = (raw || '').trim();
  if (!v) return v;

  // Match patterns like "1:30", "1 :30", "01:30", etc.
  const left2 = v.substring(0, 2);
  const left3 = v.substring(0, 3);
  const suffix = v.substring(v.indexOf(':'));

  // "1 :" or starts with "01" (single digit with space)
  if (left2 === '01' || left3 === '1 :') return '13' + suffix.replace(/^ :/, ':');
  if (left2 === '02' || left3 === '2 :') return '14' + suffix.replace(/^ :/, ':');
  if (left2 === '03' || left3 === '3 :') return '15' + suffix.replace(/^ :/, ':');
  if (left2 === '04' || left3 === '4 :') return '16' + suffix.replace(/^ :/, ':');
  if (left2 === '05' || left3 === '5 :') return '17' + suffix.replace(/^ :/, ':');
  if (left2 === '06' || left3 === '6 :') return '18' + suffix.replace(/^ :/, ':');
  if (left3 === '7 :') return '07' + suffix.replace(/^ :/, ':');
  if (left3 === '8 :') return '08' + suffix.replace(/^ :/, ':');
  if (left3 === '9 :') return '09' + suffix.replace(/^ :/, ':');

  return v;
};

/** Fields that are always readonly */
const ALWAYS_READONLY = new Set([
  'f921_01', 'f921_19', 'f921_18', 'f921_17',
  'f921_91', 'f921_92', 'f921_93',
  'f921_22', 'f921_23', 'f921_25', 'f921_26', 'f921_27',
  'f921_72', 'f921_73', 'f921_67', 'f921_68',
]);

/** Determine if a field should be disabled */
export const isFieldDisabledFn = (key: string, isEditing: boolean, _mode: string): boolean => {
  if (!isEditing) return true;
  if (ALWAYS_READONLY.has(key)) return true;
  return false;
};
